import React, { useState ,useEffect, useRef} from "react";
import logo from "./images/CHW MANUAL.svg"
import hero from "./images/hero.svg"
import games from "./images/games.svg"
import searchcontent from "./images/searchcontent.svg"
import insights from "./images/insights.svg"
import design from "./images/design.svg"
import line from "./images/Line.svg"
import tobi from "./images/tobi.svg"
import marian from "./images/marian.svg"
import angela from "./images/angela.svg"
import collaboration from "./images/collaboration.svg"
import Manchester from "./svg/manchester-1.svg"
import Babcock from "./svg/babcock.svg"
import Ibadan from "./svg/ibadan.svg"
import qa from "./images/qa.gif"
import { motion } from "framer-motion";
import start from "./images/start.svg"
import { Link } from "react-router-dom";

const LandingPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    
  return (
    <div className="min-h-screen bg-[#EDF0F5] text-gray-900 text-xl">
      {/* Navbar */}
      <nav className=" px-6 py-6 md:px-20 md:py-10 flex flex-col">
        <div className="flex justify-between items-center">
          <h2 className=" font-bold text-3xl text-[#091F5B]">CHW MANUAL</h2>
          {/* <img src={logo} alt="CHW Manual Logo" className="w-32 md:w-auto" /> */}
          {/* Desktop Navigation */}
          <ul className="hidden md:flex text-black space-x-14 text-lg">
            <li><a href="/" className="hover:underline hover:text-blue-600">Home</a></li>
            {/* <li><a href="/chapter1/video" className="hover:underline hover:text-blue-600">Manual</a></li> */}
            <li><a href="/chapter1/video" className="hover:underline hover:text-blue-600">Explore Manual</a></li>
            {/* <li>
              <input
                type="text"
                placeholder="Search..."
                className="px-4 bg-[#D0E4FF] rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
            </li> */}
          </ul>
          {/* Mobile Hamburger Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="focus:outline-none"
              aria-label="Toggle Navigation Menu"
            >
              {isOpen ? (
                // Close Icon (X)
                <svg
                  className="w-8 h-8 text-black"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                // Hamburger Icon
                <svg
                  className="w-8 h-8 text-black"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
        {/* Mobile Navigation Menu */}
        {isOpen && (
          <ul className="mt-4 flex flex-col space-y-4 md:hidden text-black">
            <li><a href="#home" className="hover:underline">Home</a></li>
            {/* <li><a href="/chapter1/video" className="hover:underline hover:text-blue-600">Manual</a></li> */}
            <li><a href="/chapter1/video" className="hover:underline hover:text-blue-600">Explore Manual</a></li>
            {/* <li>
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-4 py-2 bg-[#D0E4FF] rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
            </li> */}
          </ul>
        )}
      </nav>


      {/* Header Section */}
      <header className="text-left p-6 md:p-20 flex flex-col md:flex-row text-[#091F5B]">
        <div className="my-auto md:mr-20">
          <h2 className="text-4xl md:text-5xl pr-12">Welcome to The Community Health Workers Research Training</h2>
          <p className="mt-4 font-light pr-10 md:pr-40 mx-auto md:text-xl">
            Empowering Community Health Workers for Impact. Discover a basic resource designed to enhance your skills and knowledge as a community health worker.
          </p>
          <Link to="/chapter1/video">
          <button className="mt-6 bg-[#091F5B] text-white px-10 py-3 rounded-2xl font-bold">
            Get Started
          </button>
          </Link>
        </div>
        <div className="m-auto p-10">
          <img 
              src={hero} 
              alt="Community Health Worker" 
              className="m-auto drop-shadow-[10px_20px_60px_#6F96D1]" 
          />
        </div>
      </header>


      {/* What’s Inside Section */}
      <section className="py-16 px-6 text-[#091F5B] text-center">
        <h3 className="text-3xl md:text-5xl font-extralight">What’s inside the manual?</h3>
        <p className="mt-4 max-w-3xl mx-auto md:text-xl">
          This manual is a comprehensive resource designed to support community health workers with practical tools, research insights, and collaborative opportunities.
        </p>
      </section>

      {/* Features Section */}
      
      <section className="px-6 md:px-40 text-center text-[#091F5B] overflow-x-auto  ">
  <div className="flex flex-nowrap gap-8 md:gap-12">
    {/* Feature 1 */}
    <div className="flex-shrink-0 w-full lg:w-1/2 bg-white rounded-lg shadow-sm">
      <div className="flex flex-col lg:flex-row items-center px-6 py-16">
        <div className="lg:w-1/2">
          <img src={games} alt="Interactive Q&A Games" className="m-auto" />
        </div>
        <div className="lg:w-1/2 mt-4 md:mt-0 md:pl-6">
          <h4 className=" font-bold text-xl md:text-2xl">Interactive Q&A Games</h4>
          <p className="mt-2 text-gray-600 md:text-lg">
            Dive into an engaging learning experience with our interactive Q&A game. Test your understanding while exploring key concepts in a practical way.
          </p>
        </div>
      </div>
    </div>

    {/* Feature 2 (Text on Left, Image on Right) */}
    <div className="flex-shrink-0 w-full lg:w-1/2 bg-white rounded-lg shadow-sm">
      <div className="flex flex-col lg:flex-row items-center px-6 py-16">
        <div className="lg:w-1/2 order-2 md:order-1 mt-4 md:mt-0 md:pr-6">
          <h4 className="text-xl font-bold md:text-2xl">Searchable Content</h4>
          <p className="mt-2 text-gray-600 md:text-lg">
            Say goodbye to endless scrolling. Our powerful search feature ensures you can quickly find the information you need, whether it’s within a chapter, FAQ, or resource.
          </p>
        </div>
        <div className="lg:w-1/2 order-1 md:order-2">
          <img src={searchcontent} alt="Searchable Content" className="m-auto" />
        </div>
      </div>
    </div>

    {/* Feature 3 */}
    <div className="flex-shrink-0 w-full lg:w-1/2 bg-white rounded-lg shadow-sm">
      <div className="flex flex-col lg:flex-row items-center px-6 lg:py-16">
        <div className="lg:w-1/2">
          <img src={insights} alt="Collaborative Research Insights" className="m-auto" />
        </div>
        <div className="lg:w-1/2 mt-4 md:mt-0 lg:pl-6">
          <h4 className="text-xl font-bold md:text-2xl">Collaborative Research Insights</h4>
          <p className="mt-2 text-gray-600 md:text-lg">
            Discover the strength of collaboration with insights contributed by leading universities. This manual combines expert research with practical applications.
          </p>
        </div>
      </div>
    </div>

    {/* Feature 4 (Text on Left, Image on Right) */}
    <div className="flex-shrink-0 w-full lg:w-1/2 bg-white rounded-lg shadow-sm">
      <div className="flex flex-col lg:flex-row items-center px-6 py-16">
        <div className="lg:w-1/2 order-2 md:order-1 mt-4 md:mt-0 lg:pr-6">
          <h4 className="text-xl font-bold md:text-2xl">Accessible Design</h4>
          <p className="mt-2 text-gray-600 md:text-lg">
            We’ve designed this manual to be user-friendly for everyone, including older demographics. High-contrast colors, clear fonts, and intuitive navigation ensure an effortless experience.
          </p>
        </div>
        <div className="lg:w-1/2 order-1 lg:order-2">
          <img src={design} alt="Accessible Design" className="m-auto" />
        </div>
      </div>
    </div>
  </div>
</section>



      {/* Meet the Researchers */}
      {/* <section className="py-16 text-center">
        <h3 className="text-2xl font-bold text-[#091F5B]">Meet the Researchers</h3>
        <div className="mt-16 lg:mt-28 flex flex-wrap justify-center gap-28 lg:gap-10">
          <div className="text-center bg-[#99B5DD] px-6 py-8 rounded-xl space-y-7">
            <img src={tobi} alt="Dr. Tobi James" className="m-auto rounded-full -mt-24"/>
            <p className="font-bold">Dr. Tobi James</p>
            <p className="text-gray-600">Researcher</p>
          </div>
          <div className="text-center -mt-10 bg-[#99B5DD] px-6 py-8 rounded-xl space-y-7">
            <img src={marian} alt="Dr. Marian Thompson" className="m-auto rounded-full -mt-24"/>
            <p className="font-bold">Dr. Marian Thompson</p>
            <p className="text-gray-600">Lead Researcher</p>
          </div>
          <div className="text-center bg-[#99B5DD] px-6 py-8 rounded-xl space-y-7">
            <img src={angela} alt="Dr. Angela Nzike" className="m-auto rounded-full -mt-24"/>
            <p className="font-bold">Dr. Angela Nzike</p>
            <p className="text-gray-600">Researcher</p>
          </div>
        </div>
      </section> */}


      {/* Collaboration Section */}
      <section className="py-16 text-center px-6">
        <h3 className="text-3xl md:text-4xl font-extralight text-[#091F5B]">In Collaboration With</h3>
        <div className="m-auto mt-12 bg-transparent  ">
          <img src={Manchester} alt="Collaboration" className="m-auto  md:w-1/3"/>
        </div>
        <div className="flex flex-col lg:flex-row md:justify-between">
          
        <img src={Babcock} alt="Collaboration" className="m-auto md:w-1/3"/>
          <img src={Ibadan} alt="Collaboration" className="m-auto md:w-1/3"/>
        </div>
      </section>

      {/* Interactive Q&A Section */}
      <section className="py-16 text-center px-6">
        <h3 className="md:text-4xl text-2xl font-bold mb-6 text-[#091F5B]">Explore Our Interactive Q&A Feature!</h3>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8">
          <div className="w-full md:w-1/2">
            <img src={qa} alt="Interactive Q&A Feature" className="mx-auto rounded-lg"/>
          </div>
          <div className="w-full md:w-1/2 text-left">
            <h1 className="text-3xl font-semibold mb-4">What Makes This Feature Special?</h1>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Interactive Learning Made Simple</li>
              <li>Get Immediate Feedback on Answers</li>
              <li>Designed for Real-World Application</li>
              <li>Fun and Engaging for All Users</li>
            </ul>
                <Link to="/chapter1/video">
            <button className="mt-6 bg-[#091F5B] text-white px-10 py-3 rounded-full font-bold hover:bg-[#6F96D1] transition duration-300 ease-in-out">
              Explore Now!
            </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 text-center px-6">
        <h1 className="text-4xl font-bold mb-6 text-[#091F5B]">Ready to get started?</h1>
        <div className="flex flex-col md:flex-row items-center px-8 md:px-32 justify-center gap-8">
          <div className="w-full md:w-1/2 text-center">
            <h1 className="text-3xl font-semibold mb-4">Explore, Learn, and Transform with Just a Click!</h1>
            <p className="text-gray-600">Unlock a world of knowledge and interactive tools designed to empower and inspire. Your journey begins here!</p>
             <Link to="/chapter1/video">
            <button className="mt-8 bg-[#091F5B] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#6F96D1] transition duration-300 ease-in-out">
              Get Started
            </button>
            </Link>
          </div>
          <div className="w-full md:w-1/2">
            <img src={start} alt="Start" className="m-auto"/>
          </div>
        </div>
      </section>
        {/* Footer */}
        <footer className="bg-[#344EAD] text-white py-8 px-10 text-center mt-16">
  <div className="flex flex-col md:flex-row justify-center text-left space-x-0 md:space-x-16 mt-4">
    <ul className="space-y-5 mb-6 md:mb-0">
      <li><a href="#home" className="hover:underline">Home</a></li>
      <li><a href="#about" className="hover:underline">About the Manual</a></li>
      <li><a href="#qa" className="hover:underline">Interactive Q&A</a></li>
    </ul>
    <ul className="space-y-5 mb-6 md:mb-0">
      <li><a href="#collaboration" className="hover:underline">Collaboration with Universities</a></li>
      <li><a href="#faqs" className="hover:underline">FAQs</a></li>
    </ul>
    <ul className="space-y-5">
      <li><a href="#privacy" className="hover:underline">Privacy Policy</a></li>
      <li><a href="#terms" className="hover:underline">Terms of Service</a></li>
    </ul>
  </div>
  <hr className="border border-white my-10 h-[1px]" />
  <p className="text-sm">© 2025 CHWM. All Rights Reserved</p>
</footer>

    </div>
  );
};

export default LandingPage;
